import axios from "axios"
import { APIURL } from "src/config/helpers/base"

export const setDataInfoGraphics = () => {
    return (dispatch) => {
        dispatch({ type: 'DATA_INFO_GRAPICHS', payload: false })
        axios.get(`${APIURL}/one/Webs/GetInfoGraphics`).then(res => {
            var data = res.data;
            if (res.status == 204) {
                dispatch({ type: 'DATA_INFO_GRAPICHS', payload: [] })
                return;
            }
            setTimeout(() => {
                dispatch({ type: 'DATA_INFO_GRAPICHS', payload: data })
            }, 1000);
        })
    }
}

export const setDataInfoGraphic = (slug) => {
    return (dispatch) => {
        dispatch({ type: 'DATA_INFO_GRAPICH', payload: false })
        axios.get(`${APIURL}/one/Webs/GetInfoGraphic?slug=${slug}`).then(res => {
            var data = res.data;
            setTimeout(() => {
                dispatch({ type: 'DATA_INFO_GRAPICH', payload: data })
            }, 1000);
        })
    }
}